// Service for admin reference code whitelist management
import type { ReferenceCode } from '../types/referenceCode';
import { apiRequest } from '@startus/lib';

export const referenceCodesService = {
  /** Fetches all whitelisted reference codes */
  async getReferenceCodes(): Promise<ReferenceCode[]> {
    const response = await apiRequest<{ data: ReferenceCode[] }>('/api/v1/admin/reference-codes');
    return response.data;
  },

  /** Creates a reference code with the provided value */
  async createReferenceCode(code: string): Promise<ReferenceCode> {
    const response = await apiRequest<{ data: ReferenceCode }>('/api/v1/admin/reference-codes', {
      method: 'POST',
      body: JSON.stringify({ code }),
    });
    return response.data;
  },

  /** Deletes a reference code by its string value (not id) */
  async deleteReferenceCode(code: string): Promise<void> {
    await apiRequest(`/api/v1/admin/reference-codes/${encodeURIComponent(code)}`, {
      method: 'DELETE',
    });
  },
};
